import { ToastProviderProps } from '@chakra-ui/react';

export const toastOptions: ToastProviderProps = {
  defaultOptions: {
    containerStyle: {
      bgColor: 'chakra-subtle-bg',
      borderRadius: 'lg',
      maxWidth: 'sm',
      mt: 8,
      mb: -4,
      zIndex: 10000, // ensure toasts appear above modals/overlays in all apps
    },
    duration: 8000,
    position: 'top-right',
    variant: 'left-accent',
  },
  motionVariants: {
    initial: {
      opacity: 0,
      x: '96px',
    },
    animate: {
      opacity: 1,
      x: 0,
    },
    exit: {
      opacity: 0,
      x: '32px',
      transition: {
        ease: 'easeInOut',
      },
    },
  },
};
